import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FAQ, IStrapiDocuments } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { PageRetrievalErrorComponent } from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { RenderMarkdownComponent } from '../../../shared/components/render-markdown/render-markdown.component';

@Component({
    selector: 'app-view-faq',
    templateUrl: './view-faq.component.html',
    styleUrls: ['./view-faq.component.scss'],
    imports: [
        BreadcrumbsComponent,
        NgIf,
        PageRetrievalErrorComponent,
        RenderMarkdownComponent,
    ],
})
export class ViewFaqComponent implements OnInit {
  public theFAQ: FAQ = <FAQ>{};

  public faqRetrievalError = false;

  private cdr = inject(ChangeDetectorRef);

  constructor(
    private readonly route: ActivatedRoute,

    public readonly strapi: StrapiService
  ) {}

  ngOnInit() {
    // First get the product id from the current route.
    const routeParams = this.route.snapshot.paramMap;
    const faqUID = String(routeParams.get('faqUID'));

    if (faqUID) {
      this.strapi.getDocumentByUID('faqs', faqUID).subscribe({
        next: (data: IStrapiDocuments<FAQ>) => {
          this.theFAQ = data.data[0].attributes;
          this.cdr.markForCheck();
        },
        error: () => {
          this.faqRetrievalError = true;
          this.cdr.markForCheck();
        },
      });
    }
  }
}
